import React from "react";
import { DetailsSection } from "components/DetailsSection";
import { VehicleIcon } from "components/icons/Icons";
import { VehicleDetails } from "generated/types/types";
import { useTranslation } from "react-i18next";

type Props = {
    vehicleDetails: VehicleDetails;
};

/**
 * A component for displaying the details of the vehicle the booking is for.
 */
export const VehicleDetailsSection: React.FC<Props> = props => {
    const { t } = useTranslation();
    return (
        <DetailsSection
            iconComponent={VehicleIcon}
            heading={t("vehicle_details")}
            lines={[
                { text: props.vehicleDetails.make + " " + props.vehicleDetails.model + " " + props.vehicleDetails.derivative },
                { prefix: t("vehicle_details_reg_no"), text: props.vehicleDetails.registrationNumber },
            ]}
        />
    );
};
